/**
 * Spanish (es) mappings for HomePage and Homepage Panel Components
 */

export const homepageES = {
  // BettingPlatformsCard
  "Ask About Your Favorite Fantasy or Sports Bets": "Pregunta Sobre Tus Apuestas Deportivas o Fantasy Favoritas",
  "Get insights on your bets across these platforms": "Obtén información sobre tus apuestas en estas plataformas",
  "Live betting analysis & insights": "Análisis e información de apuestas en vivo",

  // Platform names (keep as-is for brand recognition)
  "Rei do pitaco": "Rei do pitaco",
  "Superbet": "Superbet",
  "PixBet": "PixBet",
  "FanDuel": "FanDuel",
  "DraftKings": "DraftKings",
  "Bet365": "Bet365",

  // Premium button
  "Unlock Premium Features": "Desbloquear Funciones Premium",

  // Footer
  "About Us": "Acerca de Nosotros",
  "FAQ": "Preguntas Frecuentes",

  // SuggestionChips
  "Try PickStar's AI analytics suggestions or craft your custom question above!": "¡Prueba las sugerencias de análisis IA de PickStar o crea tu propia pregunta arriba!",

  // Error messages
  "Error processing message": "Error al procesar el mensaje",
  "Network response was not ok": "La respuesta de red no fue correcta",

  // PremiumUpsellBanner
  "PREMIUM ACCESS": "ACCESO PREMIUM",
  "Premium Access": "Acceso Premium",
  "Unlock Your AI Assistant's Full Power with StarCoins": "Desbloquea Todo el Poder de Tu Asistente IA con StarCoins",
  "Unlimited messages • Advanced analytics • Priority support": "Mensajes ilimitados • Análisis avanzados • Soporte prioritario",
  "Unlimited messages • Advanced analytics • Priority support • Custom sports insights": "Mensajes ilimitados • Análisis avanzados • Soporte prioritario • Información deportiva personalizada",
  "Upgrade Now": "Actualizar Ahora",

  // Homepage Command Center Headers
  "Command Center": "Centro de Comando",
  "Quick Actions": "Acciones Rápidas",
  "Recent Activity": "Actividad Reciente",
  "Trending Games": "Juegos en Tendencia",
  "Connected": "Conectado",
  "PRO": "PRO",
  "BASIC": "BÁSICO",

  // Premier League Banner
  "Premier League!": "Premier League!",
  "Premier League is Back!": "¡La Premier League Ha Vuelto!",
  "Expert match predictions": "Predicciones de partidos",
  "Get expert predictions for all matches": "Obtén predicciones expertas para todos los partidos",
  "View Matches": "Ver Partidos",

  // QuickActionsGrid
  "New Chat": "Nuevo Chat",
  "Start New Chat": "Iniciar Nuevo Chat",
  "Ask your AI assistant": "Pregunta a tu asistente IA",
  "QuickPicks": "Picks Rápidos",
  "Fast AI predictions": "Predicciones rápidas de IA",
  "Buy Coins": "Comprar Monedas",
  "Get StarCoins for premium": "Obtén StarCoins para premium",
  "AI Exchange": "Intercambio IA",
  "Market insights & trends": "Información y tendencias del mercado",
  "Sports Hub": "Centro Deportivo",
  "Live stats & predictions": "Estadísticas y predicciones en vivo",
  "Market View": "Vista del Mercado",
  "Browse active games": "Explorar juegos activos",

  // HistorySection
  "Recent Conversations": "Conversaciones Recientes",
  "No conversations yet": "Aún no hay conversaciones",
  "Start your first chat": "Inicia tu primer chat",
  "Start your first chat →": "Inicia tu primer chat →",
  "View all conversations": "Ver todas las conversaciones",
  "View all conversations →": "Ver todas las conversaciones →",
  "New conversation": "Nueva conversación",
  "Just now": "Ahora mismo",
  "Continue": "Continuar",
  "Sign in to view your conversation history": "Inicia sesión para ver tu historial de conversaciones",
  "Sign in": "Iniciar sesión",

  // BottomNavBar
  "Home": "Inicio",
  "Chat": "Preguntar IA",
  "Sports": "Deportes",
  "Profile": "Perfil",
  "History": "Historial",
  "Account": "Cuenta",

  // Time formatting
  "m ago": "m atrás",
  "h ago": "h atrás",
  "d ago": "d atrás",

  // Economy Strip
  "StarCoins": "StarCoins",
  "Spins Left": "Giros Restantes",
  "Day": "Día",
  "Streak": "Racha",
  "in": "en",
  "days": "días",

  // Featured Games
  "Featured Games": "Juegos Destacados",
  "Want all games?": "¿Quieres todos los juegos?",
  "Here": "Aquí",
  "Today's Top Matches": "Mejores Partidos de Hoy",
  "See All Games": "Ver Todos los Juegos",
  "View All Games": "Ver Todos los Juegos",
  "Games & Picks": "Juegos y Picks",
  "View Game": "Ver Juego",
  "Match Finished": "Partido Finalizado",
  "Home": "Local",
  "Draw": "Empate",
  "Away": "Visitante",

  // StarCoinPromoCard
  "Limited Offer": "Oferta Limitada",
  "SIGN UP": "REGÍSTRATE",
  "TODAY": "HOY",

  // Navigation
  "Tour": "Tour",
  "&": "&",
  "GET": "OBTÉN",
  "200": "200",
  "STARCOIN": "STARCOIN",
  "BONUS": "BONO",
  "*On 1K StarCoin packages and above": "*En paquetes de 1K StarCoins o más",
  "Claim Now": "Reclamar Ahora",

  // Daily Allowances Banner
  "Free Daily Access": "Acceso Diario Gratis",
  "AI Chats": "Chats IA",
  "X-Pick": "X-Pick",
  "In-Depth Game Prediction": "Predicción de Juego Detallada",

  // AIExchangePromoCard
  "AI Market Live": "Mercado IA en Vivo",
  "AI EXCHANGE": "INTERCAMBIO IA",
  "Track AI consensus & market trends": "Rastrea el consenso IA y tendencias del mercado",
  "LIVE": "EN VIVO",
  "1. Buy Coins": "1. Comprar Monedas",
  "2. Use Quick Picks": "2. Usar Picks Rápidos",
  "3. Compete!": "3. ¡Competir!",
  "4. Vote on games": "4. Votar en juegos",
  "See what 50K+ bettors are tracking": "Ve qué están rastreando más de 50K apostadores",
  "Explore Now": "Explorar Ahora",

  // Game Card Long Press Actions
  "Send to AI Chat": "Enviar al Chat IA",
  "Ask PickAI for predictions and insights about this match": "Pregunta a PickAI por predicciones e información sobre este partido",
  "Send to Chat": "Enviar al Chat",
  "Sent to Chat": "Enviado al Chat",
  "Sent to Chat!": "¡Enviado al Chat!",
  "AI Analysis Options": "Opciones de Análisis IA",
  "Full Analysis": "Análisis Completo",
  "Quick Take": "Análisis Rápido",
  "Compare": "Comparar Equipos",
  "Best Bets": "Mejores Apuestas",

  // Game status
  "LIVE": "EN VIVO",
  "FT": "FIN",
  "HT": "MT",
  "Not started": "No iniciado",
  "Live": "En Vivo",
  "Final": "Final",
  "Upcoming": "Próximo",

  // Game card prompts for chat
  "Analyze this": "Analiza este juego de",
  "game": "juego",
  "League": "Liga",
  "Status": "Estado",
  "Score": "Marcador",
  "Time": "Hora",
  "What are your predictions and betting insights for this match?": "¿Cuáles son tus predicciones e información de apuestas para este partido?",
  "Quick analysis for": "Análisis rápido para",
  "Compare teams": "Compara los equipos",
  "in": "en",
  "Best bets for": "Mejores apuestas para",
  "Current": "Actual",
  "vs": "vs",

  // Enhanced Game Card - Prediction Feature
  "Predict": "Predicción",
  "Predicting...": "Prediciendo...",
  "Chat": "Chat",
  "Sent": "Enviado",
  "Add to chat": "Añadir al chat",
  "7 coins?": "¿7 monedas?",
  "Spend 7 coins for AI prediction?": "¿Gastar 7 monedas para predicción IA?",
  "Use free xPicks?": "¿Usar xPicks gratis?",
  "Spend 9 coins for xPicks?": "¿Gastar 9 monedas para xPicks?",
  "Your prediction will be saved in chat history!": "¡Tu predicción se guardará en el historial del chat!",
  "Cancel": "Cancelar",
  "Confirm": "Confirmar",
  "AI Pick": "Pick IA",
  "Analyze in Chat": "Analizar en Chat",

  // Prediction Confirmation Modal
  "AI Quick Prediction": "Predicción Rápida IA",
  "Cost": "Costo",
  "Star Coins": "Star Coins",
  "Your balance": "Tu saldo",
  "coins": "monedas",
  "You need": "Necesitas",
  "more coins for this prediction": "más monedas para esta predicción",
  "What you get": "Lo que obtienes",
  "AI-powered winner prediction": "Predicción de ganador con IA",
  "Confidence level (HIGH/MED/LOW)": "Nivel de confianza (ALTO/MEDIO/BAJO)",
  "Brief reasoning for the prediction": "Breve razonamiento para la predicción",
  "1-hour cached result (no re-charge)": "Resultado en caché por 1 hora (sin recargo)",
  "Star Coins are refunded if prediction fails": "Las Star Coins se reembolsan si la predicción falla",
  "Get Prediction": "Obtener Predicción",
  "Get more Star Coins": "Obtener más Star Coins",

  // NuclearTopRail Navigation Pills
  "QuickPicks": "Picks Rápidos",
  "Buy Coins": "Comprar Monedas",
  "AI Market": "Mercado IA",

  // SportsFeed EmptyState
  "No trending games right now": "No hay juegos en tendencia ahora",
  "Please refresh, or try the": "Por favor, actualiza o prueba el",
  "sports hub": "centro deportivo",
  "for all games": "para todos los juegos",
  "No live football games right now": "No hay juegos de fútbol en vivo ahora",
  "No live MLB games right now": "No hay juegos de MLB en vivo ahora",
  "No live NFL games right now": "No hay juegos de NFL en vivo ahora",
  "No matches found for this league": "No se encontraron partidos para esta liga",
  "Check back during game time": "Vuelve durante la hora del juego",
  "Try selecting a different league or check \"All Leagues\"": "Intenta seleccionar una liga diferente o marca \"Todas las Ligas\"",
  "Week 1 starts September 4, 2025": "Semana 1 comienza el 4 de septiembre de 2025",
  "Retry": "Reintentar",
  "Clear Filters": "Limpiar Filtros",

  // NuclearTopRail - Tab Labels
  "Trending": "Tendencias",
  "Live": "En Vivo",
  "Upcoming": "Próximos",
  "Next": "Próximos",
  "All": "Todos",
  "Start Researching in Chat": "Comenzar Investigación en Chat",

  // Auth Modal
  "Sign in to continue": "Inicia sesión para continuar",
  "Create a free account to access this feature": "Crea una cuenta gratuita para acceder a esta función",
  "Start chatting with AI": "Comienza a chatear con IA",
  "Sign in to get personalized sports insights and predictions": "Inicia sesión para obtener información y predicciones deportivas personalizadas",
  "View your history": "Ver tu historial",
  "Sign in to access your conversation history and saved predictions": "Inicia sesión para acceder a tu historial de conversaciones y predicciones guardadas",
  "Access live sports data": "Acceder a datos deportivos en vivo",
  "Sign in to get real-time sports updates and analytics": "Inicia sesión para obtener actualizaciones deportivas y análisis en tiempo real",
  "Get AI predictions": "Obtener predicciones IA",
  "Sign in to receive AI-powered game predictions and analysis": "Inicia sesión para recibir predicciones y análisis de juegos con IA",
  "Manage Star Coins": "Administrar Star Coins",
  "Sign in to view and use your Star Coins balance": "Inicia sesión para ver y usar tu saldo de Star Coins",
  "Join thousands of users getting AI-powered sports insights": "Únete a miles de usuarios obteniendo información deportiva con IA",
  "Continue with Google": "Continuar con Google",
  "or": "o",
  "Already have an account? Sign in": "¿Ya tienes una cuenta? Inicia sesión",
  "Free to start": "Gratis para comenzar",
  "No credit card": "Sin tarjeta de crédito",
  "Cancel anytime": "Cancela en cualquier momento"
};
